import React from 'react';

interface HeaderProps {
  header: string;
  subheader: string;
}

const Header = ({ header, subheader }: HeaderProps): JSX.Element => {
  return (
    <header className="mx-auto mb-64 max-w-3xl px-16 text-center xs:px-32 sm:mb-80 sm:px-0">
      <h1 className="m-0 mb-8 font-suisse-screen text-headline-alt-lg text-black sm:text-headline-alt-xl">
        {header}
      </h1>
      <p className="m-0 font-suisse-neue text-subheadline-sm text-black">{subheader}</p>
    </header>
  );
};

export default Header;
